import { useEffect } from 'react';
import { SerializedError } from '@reduxjs/toolkit';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { useQueryScopeName } from './scopeHook';
import { replace, push, useRouteMatch } from '../../app/route';
import {
  getScopeListUrl,
  getScopeDetailUrl,
  UpdateScopeActionResponse,
} from './scopeSlice';
import {
  selectCurrentTenantId,
} from '../user/userSlice';
import { ScopeCreateForm } from './ScopeCreateForm';
import { ScopeEditForm } from './ScopeEditForm';
import { ScopeView } from './ScopeView';

type PathParams = {
  mode: 'view'|'edit'|'create';
  tenant_id: string;
};

export function ScopePage() {
  const dispatch = useAppDispatch();
  const match = useRouteMatch<PathParams>();
  const { mode } = match.params;
  const scope_name = useQueryScopeName();
  const tenant_id = useAppSelector(selectCurrentTenantId);

  useEffect(() => {
    if (['view', 'edit'].includes(mode) && !scope_name) {
      dispatch(replace(getScopeListUrl(tenant_id)));
    }
  }, [dispatch, scope_name, mode, tenant_id]);
  useEffect(() => {
    if (tenant_id !== match.params.tenant_id) {
      dispatch(push(getScopeListUrl(tenant_id)));
    }
  }, [tenant_id, dispatch, match.params.tenant_id]);

  const handleCreateCallback = (scope_name: string) => {
    dispatch(push(getScopeDetailUrl(tenant_id, scope_name, 'view')));
  };
  const handleUpdateCallback = (result: UpdateScopeActionResponse) => {
    dispatch(push(getScopeDetailUrl(tenant_id, scope_name, 'view')));
  };
  const handleDismissCallback = (error?: SerializedError) => {
    if (error) {
      dispatch(push(getScopeListUrl(tenant_id)));
    } else if (mode === 'create') {
      dispatch(push(getScopeListUrl(tenant_id)));
    } else if (mode === 'edit' || mode === 'view') {
      dispatch(push(getScopeDetailUrl(tenant_id, scope_name, 'view')));
    }
  };
  const handleGoBack = () => {
    dispatch(push(getScopeListUrl(tenant_id)));
  };
  return (
    <div className="container">
      <div className="d-flex justify-content-between py-4">
        { mode === 'create' && <h1>Create Scope</h1> }
        { mode === 'edit' && <h1>Edit Scope</h1> }
        { mode === 'view' && <h1>View Scope</h1> }
        { mode === 'view' && 
          <button className="btn btn-primary my-2" onClick={handleGoBack}>
            GoBack
          </button>
        }
      </div>
      { mode === 'create' && 
        <ScopeCreateForm
          tenant_id={tenant_id}
          successCallback={handleCreateCallback}
          dismissCallback={handleDismissCallback}
        />
      }
      { mode === 'edit' && 
        <ScopeEditForm
          tenant_id={tenant_id}
          scope_name={scope_name}
          successCallback={handleUpdateCallback}
          dismissCallback={handleDismissCallback}
        />
      }
      { mode === 'view' &&
        <ScopeView
          tenant_id={tenant_id}
          scope_name={scope_name}
          closeCallback={handleDismissCallback}
        />
      }
    </div>
  );
}
